import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const SolesFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Cuenta PEN' htmlFor='input-soles' md={12} />
      <Col md={12}>
        <Field name='cuentaContable12PEN'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-soles' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SolesFormGroup)
